import React, { useState, useEffect } from "react";
import Pagination from '../../../../components/pagination/Pagination.jsx';
import columns from "../../../../columns/ib/MT5Account/MT5PendingAccounts.js";
import TableWithSkeleton from '../../../../components/table/TableWithSkeleton.jsx';
import ConfirmationModal from "../../../../components/modals/ConfirmationModal.jsx";
import { GetAllAccountApi, AccountRequestAcceptRejectApi } from '../../../../api/request/liveAccount.js';
import toast from "react-hot-toast";
import moment from "moment";
import ModalComponent from '../../../../components/modals/ModalComponent.jsx';
import { Form, Input } from 'antd';
import LoadableButton from '../../../../components/buttons/LoadableButton.jsx';
const { TextArea } = Input;

export default function Accounts({ searchText }) {

    const [rejectForm] = Form.useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [filter, setFilter] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [data, setData] = useState([]);
    const [v2fxAccept, setV2fxAccept] = useState(false);
    const [initialValues, setInitialValues] = useState({ comment: '' });
    const [v2fxRejection, setV2fxRejection] = useState(false);
    const [isReqLoading, setIsReqLoading] = useState(false);
    const [selectedV2fx, setSelectedV2fx] = useState({ userId: null, V2fxAccountId: null });
    const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
    const [sorter, setSorter] = useState({ SortBy: 'createdDate', SortOrder: '' });

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'createdDate', SortOrder: '' });
        }
    };

    const setSelectedV2fxId = (userId, V2fxAccountId) => {
        setSelectedV2fx({ userId, V2fxAccountId });
    };

    const getPendingAccounts = async () => {
        try {
            let params = {
                PageNumber: page,
                PageSize: pageSize,
                SearchText: searchText,
                FilterText: "Pending",
                ...sorter
            }
            setIsLoading(true);
            const { data } = await GetAllAccountApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        const { userId, V2fxAccountId } = item;

                        return {
                            ...item,
                            name: `${item?.firstName} ${item?.lastName}`,
                            createdDate: (item?.createdDate ? moment(item?.createdDate).format("DD-MM-YYYY, hh:mm A") : null),
                            balance: `$ ${item?.balance}`,
                            // actions: (
                            //     <div className="flex">
                            //         <button
                            //             className="mr-3 ml-3"
                            //             onClick={() => {
                            //                 setSelectedV2fxId(userId, V2fxAccountId);
                            //                 setV2fxAccept(true);
                            //             }}
                            //         >
                            //             <img src="/assets/icons/accept_icon.svg" alt="icon" width={27} />
                            //         </button>
                            //         <button onClick={() => {
                            //             setSelectedV2fxId(userId, V2fxAccountId);
                            //             setV2fxRejection(true)
                            //         }}><img src="/assets/icons/delete_icon.svg" alt="icon" width={27} /></button>
                            //     </div>
                            // ),
                        };
                    })
                );
                setTotalRecord(data?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        getPendingAccounts();
    }, [page, pageSize, searchText, filter, sorter]);

    useEffect(() => {
        if (!v2fxRejection) {
            rejectForm?.resetFields();
        }
    }, [v2fxRejection]);

    const V2fxRequestHandlerApproved = async (value) => {
        try {
            setIsReqLoading(true);
            let params = {
                V2fxAccountId: selectedV2fx?.V2fxAccountId,
                approveReject: true,
                comment: 'Accepted by IB.',

            }
            const { data } = await AccountRequestAcceptRejectApi(params);
            if (data?.success) {
                toast.success(data?.message);
                getPendingAccounts();
                rejectForm?.resetFields();
            }
            setIsReqLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.message);
            setIsReqLoading(false);
        }
        if (value) {
            setV2fxAccept(false);
        } else {
            setV2fxRejection(false);
        }
    }

    const MT5RequestHandlerRejected = async (value) => {
        try {
            setIsLoadingSubmit(true);
            let params = {
                V2fxAccountId: selectedV2fx?.V2fxAccountId,
                approveReject: false,
                comment: value?.comment,
            }
            const { data } = await AccountRequestAcceptRejectApi(params);
            if (data?.success) {
                toast.success(data?.message);
                getPendingAccounts();
                rejectForm?.resetFields();
                setV2fxRejection(false);
            }
            setIsLoadingSubmit(false);
        } catch (error) {
            toast.error(error?.response?.data?.message);
            setIsLoadingSubmit(false);
        }
    }

    return (
        <div>
            <div className="w-full my-6">
                <div className="border border-gray-200 rounded-xl">
                    <TableWithSkeleton columns={columns} data={data} loading={isLoading} onChange={handleTableChange} />
                </div>
                <Pagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
            </div>

            {/* ---- Accept-request ---- */}
            <ConfirmationModal
                isOpen={v2fxAccept}
                setIsOpen={setV2fxAccept}
                type='success'
                message='Are you sure you want to accept this request?'
                onConfirm={() => V2fxRequestHandlerApproved(true)}
                isLoading={isReqLoading}
                loadingLabel='Accepting request...'
            />


            {/* Reject Account request modal */}
            <ModalComponent isOpen={v2fxRejection} setIsOpen={setV2fxRejection} title={'Are you sure you want to reject this request?'} width={600}>
                <Form form={rejectForm} initialValues={initialValues} onFinish={MT5RequestHandlerRejected}>
                    <label className='text-base text-[#2F2B3DCC] font-medium'>Reason of rejection</label>
                    <Form.Item name="comment" rules={[{ required: true, message: 'Please enter comment.' }]}>
                        <TextArea rows={4} placeholder='Describe reason...' />
                    </Form.Item>
                    <div className='flex items-center justify-end gap-5 mt-5'>
                        <button type='button' onClick={() => setV2fxRejection(false)} className='bg-secondary text-sm text-white font-semibold px-6 py-2 rounded-lg themeSecondaryHover duration-500'>Cancel</button>
                        <LoadableButton
                            type='submit'
                            className='bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500'
                            lable='Reject'
                            loadingLable='Rejecting request...'
                            isLoading={isLoadingSubmit}
                        />
                    </div>
                </Form>
            </ModalComponent>
        </div>
    )
}